export default __webpack_public_path__ + "static/media/argItHover.7ceb050c.svg";